import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetGoodsHomeIdeaContentListRequest,
  GetGoodsHomeIdeaContentListResponse,
} from '../../model';

export class GetGoodsHomeIdeaContentListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsHomeIdeaContentListRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsHomeIdeaContentListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/homeIdea?${query}`,
    });
  }
}
